import { defineComponent as _defineComponent } from 'vue'
import emoji from '../EditorTools';
import useChatEditor from './useChatEditor';

export default /*#__PURE__*/_defineComponent({
  __name: 'ChatEditorPC',
  setup(__props) {

const {
  t,
  editorInputEle,
  sendMsg,
  isMessageDisabled,
  sendMessage,
  handleChooseEmoji,
} = useChatEditor();

return { __sfc: true,t, editorInputEle, sendMsg, isMessageDisabled, sendMessage, handleChooseEmoji, emoji }
}

})